var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadWhiteIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffffff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zas\xF3b 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buttony"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6.49 9.67 5.51 9.62 5.51 0 6.49 0 6.49 9.67"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 11.13,
    width: 12,
    height: 0.87
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6 10.29 0 3.73 0.71 3.16 6 8.93 11.29 3.16 12 3.73 6 10.29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhiteIco);
export default __webpack_public_path__ + "static/media/download-white-ico.19292e4776b07a5e7b45ab8f2a8eb126.svg";
export { ForwardRef as ReactComponent };